import { useContext } from 'react';
import { useHelmet, RedirectTag } from '@thd-nucleus/thd-helmet';
import { params, shape, string, useDataModel, bool } from '@thd-nucleus/data-sources';
import { RedirectContext } from './RedirectContext';
import { isNotFound, isInvalidItemId } from './rules/pip-redirect-rules';
import { ERROR_HANDLING_EXPERIENCE, handleErrors } from '../utils/redirector-utils';
import { isObsoleteBundle, isHiddenBundle } from './rules/bip-redirect-rules';

const bipHandler = ({ data, error, props }) => {
  const { itemId, bypass } = props || {};
  const invalidItemId = isInvalidItemId({ itemId });
  if (invalidItemId) {
    return new RedirectTag(invalidItemId, bypass);
  }

  const errors = handleErrors(error, ERROR_HANDLING_EXPERIENCE.PRODUCT);
  if (errors) {
    return new RedirectTag(errors, bypass);
  }

  const notFound = isNotFound({ data, itemId });
  if (notFound) {
    return new RedirectTag(notFound, bypass);
  }

  const hiddenBundle = isHiddenBundle({ data, itemId });
  if (hiddenBundle) {
    return new RedirectTag(hiddenBundle, bypass);
  }

  const obsoleteBundle = isObsoleteBundle({ data, itemId })
  if (obsoleteBundle) {
    return new RedirectTag(obsoleteBundle, bypass);
  }
  return null;
};

export const BIPRedirector = () => {
  const { itemId, bypass } = useContext(RedirectContext);

  const handlerProps = {
    itemId,
    bypass
  };

  const opts = {
    variables: {
      itemId
    },
    skip: !itemId
  };
  const { data, error } = useDataModel('product', opts);

  useHelmet('bipRedirector', { data, error, props: handlerProps }, bipHandler, [data, itemId]);

  return null;
};

BIPRedirector.displayName = 'BIPRedirector';

BIPRedirector.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    dataSources: string(),
    identifiers: shape({
      canonicalUrl: string(),
      hideItem: string()
    }),
    availabilityType: shape({
      obsolete: bool()
    })
  })
};
